import measureImg from '../assets/blog/measure-curtains.png';
import sheerBlockoutImg from '../assets/blog/sheer-vs-blockout.png';
import sfoldImg from '../assets/blog/sfold-pleat.png';
import climateImg from '../assets/blog/adelaide-climate.png';
import cleaningImg from '../assets/blog/cleaning-tips.png';
import dayNightImg from '../assets/blog/day-night-blinds.png';
import energyImg from '../assets/blog/energy-efficient.png';
import trendsImg from '../assets/blog/trends-2026.png';
import slidingImg from '../assets/blog/sliding-doors.png';
import insulationImg from '../assets/blog/curtains-insulation.png';
import shuttersImg from '../assets/blog/shutters-vs-curtains.png';
import greyWallsImg from '../assets/blog/grey-walls-curtains.png';
import installImg from '../assets/blog/install-curtains.png';
import shiftWorkersImg from '../assets/blog/shift-workers-blackout.png';
import outdoorBlindsImg from '../assets/blog/outdoor-blinds-shutters.png';
import darkRoomImg from '../assets/blog/dark-room-sleep.png';
import trend2024Img from '../assets/blog/curtain-trends-2024.png';
import apartmentImg from '../assets/blog/apartment-curtains.png';
import smartCurtainsImg from '../assets/blog/motorized-smart-curtains.png';
import highCeilingsImg from '../assets/blog/large-windows-high-ceilings.png';
import shuttersCurtainsImg from '../assets/blog/shutters-with-curtains.png';
import rentalPropertyImg from '../assets/blog/rental-property-curtains.png';
import newBuildImg from '../assets/blog/new-build-curtains.png';
import replacementImg from '../assets/blog/curtain-replacement.png';
import hillsImg from '../assets/blog/adelaide-hills-curtains.png';

const blogPosts = [
  {
    slug: 'how-to-measure-curtains-adelaide',
    title: 'How to Measure Curtains in Adelaide — Complete DIY Guide',
    excerpt: 'Learn exactly how to measure your windows for curtains like a professional. Step-by-step guide covering width, drop, and common Adelaide window types.',
    image: measureImg,
    category: 'Guides',
    date: '2026-05-10',
    readTime: '8 min read',
    keywords: 'how to measure curtains, curtain measurements adelaide, measure windows for curtains, curtain sizing guide',
    author: 'YN Dream Curtains',
  },
  {
    slug: 'sheer-vs-blockout-curtains-guide',
    title: 'Sheer vs Blockout Curtains — Which Is Best for Adelaide?',
    excerpt: 'Compare sheer and blockout curtains side by side. Light, privacy, energy efficiency explained for Adelaide homes.',
    image: sheerBlockoutImg,
    category: 'Guides',
    date: '2026-05-08',
    readTime: '7 min read',
    keywords: 'sheer vs blockout curtains, sheer curtains adelaide, blockout curtains comparison',
    author: 'YN Dream Curtains',
  },
  {
    slug: 's-fold-vs-pinch-pleat-curtains',
    title: 'S-Fold vs Pinch Pleat Curtains — Heading Style Guide',
    excerpt: 'Discover key differences between S-fold and pinch pleat headings. Which suits your Adelaide home?',
    image: sfoldImg,
    category: 'Guides',
    date: '2026-05-06',
    readTime: '6 min read',
    keywords: 's-fold curtains, pinch pleat curtains, curtain heading styles adelaide',
    author: 'YN Dream Curtains',
  },
  {
    slug: 'best-curtains-adelaide-climate',
    title: 'Best Curtains for Adelaide\'s Climate — Expert Picks',
    excerpt: 'Adelaide\'s hot summers and cool winters demand the right curtains. Our experts recommend the best fabrics and styles.',
    image: climateImg,
    category: 'Tips',
    date: '2026-05-04',
    readTime: '7 min read',
    keywords: 'best curtains adelaide, curtains for adelaide climate, thermal curtains adelaide',
    author: 'YN Dream Curtains',
  },
  {
    slug: 'curtain-cleaning-tips-adelaide',
    title: 'Curtain Cleaning Tips — How to Care for Your Curtains',
    excerpt: 'Keep your curtains fresh with our professional cleaning tips. When to steam, dry clean, or wash.',
    image: cleaningImg,
    category: 'Tips',
    date: '2026-05-02',
    readTime: '6 min read',
    keywords: 'curtain cleaning adelaide, how to clean curtains, curtain care tips',
    author: 'YN Dream Curtains',
  },
  {
    slug: 'day-night-blinds-guide',
    title: 'Day & Night Blinds — Everything You Need to Know',
    excerpt: 'Day and night blinds are Adelaide\'s fastest-growing window treatment. Learn how they work and costs.',
    image: dayNightImg,
    category: 'Guides',
    date: '2026-04-28',
    readTime: '7 min read',
    keywords: 'day night blinds adelaide, zebra blinds, dual roller blinds guide',
    author: 'YN Dream Curtains',
  },
  {
    slug: 'energy-efficient-curtains',
    title: 'Energy Efficient Curtains — Save on Heating & Cooling',
    excerpt: 'The right curtains can cut energy bills by up to 25%. Learn which fabrics provide the best insulation.',
    image: energyImg,
    category: 'Tips',
    date: '2026-04-25',
    readTime: '6 min read',
    keywords: 'energy efficient curtains adelaide, thermal curtains, insulating curtains',
    author: 'YN Dream Curtains',
  },
  {
    slug: 'curtain-trends-2026-adelaide',
    title: 'Curtain Trends 2026 — What\'s Hot in Adelaide',
    excerpt: 'From natural linens to motorised tracks — discover the biggest curtain trends for Adelaide in 2026.',
    image: trendsImg,
    category: 'Trends',
    date: '2026-04-20',
    readTime: '8 min read',
    keywords: 'curtain trends 2026, window furnishing trends adelaide, modern curtains',
    author: 'YN Dream Curtains',
  },
  {
    slug: 'best-curtains-sliding-doors',
    title: 'Best Curtains for Sliding Doors [Types, Styles & Installation]',
    excerpt: 'Transform your sliding glass doors with elegant, smooth-gliding curtains. Learn the best styles, tracks, and ideas for Adelaide homes.',
    image: slidingImg,
    category: 'Guides',
    date: '2026-05-18',
    readTime: '6 min read',
    keywords: 'curtains for sliding doors, best curtains for patio doors, sliding door curtain ideas, curtains for glass doors',
    author: 'YN Dream Curtains',
  },
  {
    slug: 'do-curtains-help-insulation-energy',
    title: 'Do Curtains Help With Insulation and Energy Bills?',
    excerpt: 'Find out exactly how much thermal curtains can save you on heating and cooling costs in Adelaide\'s extreme climate.',
    image: insulationImg,
    category: 'Tips',
    date: '2026-05-20',
    readTime: '7 min read',
    keywords: 'do curtains help with insulation, thermal curtains energy savings, energy efficient curtains',
    author: 'YN Dream Curtains',
  },
  {
    slug: 'plantation-shutters-vs-curtains-blinds',
    title: 'Plantation Shutters vs Curtains vs Blinds: The Ultimate Comparison',
    excerpt: 'Comparing costs, pros, and cons of plantation shutters, flowing curtains, and modern blinds to find the perfect window treatment.',
    image: shuttersImg,
    category: 'Guides',
    date: '2026-05-22',
    readTime: '8 min read',
    keywords: 'plantation shutters vs curtains, shutters vs blinds vs curtains, window treatments comparison',
    author: 'YN Dream Curtains',
  },
  {
    slug: 'what-color-curtains-with-grey-walls',
    title: 'What Color Curtains Go With Grey Walls? [Design Guide]',
    excerpt: 'Interior design advice on matching curtain colors to modern grey walls. Crisp whites, deep charcoals, and bold accents.',
    image: greyWallsImg,
    category: 'Design',
    date: '2026-05-24',
    readTime: '6 min read',
    keywords: 'what color curtains with grey walls, curtains for grey walls, best curtain color for grey room',
    author: 'YN Dream Curtains',
  },
  {
    slug: 'how-to-install-curtains-diy-guide',
    title: 'How to Install Curtains: Step-by-Step DIY Guide [With Video]',
    excerpt: 'Learn the interior designer secrets for hanging curtains. Proper heights, widths, and bracket installation for a professional look.',
    image: installImg,
    category: 'DIY',
    date: '2026-05-26',
    readTime: '9 min read',
    keywords: 'how to install curtains, how to hang curtains, curtain installation guide',
    author: 'YN Dream Curtains',
  },
  {
    slug: 'blackout-curtains-shift-workers',
    title: 'Blackout Curtains for Shift Workers and Better Sleep',
    excerpt: 'Struggling to sleep during the day? Learn how to completely block out sunlight and create a dark, quiet sanctuary.',
    image: shiftWorkersImg,
    category: 'Tips',
    date: '2026-05-28',
    readTime: '6 min read',
    keywords: 'blackout curtains for shift workers, best blackout curtains for sleeping, total blackout curtains',
    author: 'YN Dream Curtains',
  },
  {
    slug: 'outdoor-blinds-vs-shutters',
    title: 'Outdoor Blinds vs Outdoor Shutters: Which Should You Choose?',
    excerpt: 'Upgrade your Adelaide alfresco. We compare the weather protection, cost, and aesthetics of outdoor blinds versus aluminium shutters.',
    image: outdoorBlindsImg,
    category: 'Guides',
    date: '2026-05-30',
    readTime: '7 min read',
    keywords: 'outdoor blinds vs shutters, outdoor shutters or blinds, best outdoor covering',
    author: 'YN Dream Curtains',
  },
  {
    slug: 'how-to-make-room-dark-sleep',
    title: 'How to Make Your Room Completely Dark for Sleep',
    excerpt: 'Discover the interior designer secrets to eliminating light leaks and achieving total darkness in your bedroom.',
    image: darkRoomImg,
    category: 'Tips',
    date: '2026-06-02',
    readTime: '6 min read',
    keywords: 'how to make room completely dark, how to darken a room, blackout room ideas',
    author: 'YN Dream Curtains',
  },
  {
    slug: 'curtain-trends-2024-whats-in',
    title: 'Curtain Trends 2024: What\'s In and What\'s Out',
    excerpt: 'Explore the latest curtain designs for 2024. From warm earthy linens to the rise of smart home automation.',
    image: trend2024Img,
    category: 'Trends',
    date: '2026-06-04',
    readTime: '7 min read',
    keywords: 'curtain trends 2024, latest curtain designs, modern curtain styles 2024',
    author: 'YN Dream Curtains',
  },
  {
    slug: 'best-curtains-for-apartments',
    title: 'Best Curtains for Apartments: Privacy, Style & Rental-Friendly',
    excerpt: 'Maximise space in your small apartment with these no-drill, renter-friendly curtain solutions.',
    image: apartmentImg,
    category: 'Guides',
    date: '2026-06-06',
    readTime: '6 min read',
    keywords: 'curtains for apartments, best curtains for renters, rental friendly curtains',
    author: 'YN Dream Curtains',
  },
  {
    slug: 'motorized-curtains-smart-home',
    title: 'Motorized Curtains and Blinds: Smart Home Integration Guide',
    excerpt: 'Everything you need to know about automated window treatments, battery motors, and connecting to Alexa or Google Home.',
    image: smartCurtainsImg,
    category: 'Guides',
    date: '2026-06-08',
    readTime: '8 min read',
    keywords: 'motorized curtains, electric curtains, automated blinds, smart home curtains',
    author: 'YN Dream Curtains',
  },
  {
    slug: 'curtains-large-windows-high-ceilings',
    title: 'How to Choose Curtains for Large Windows and High Ceilings',
    excerpt: 'Don\'t let massive windows intimidate you. Learn the design rules for dressing double-height rooms and extra-long drops.',
    image: highCeilingsImg,
    category: 'Guides',
    date: '2026-06-10',
    readTime: '7 min read',
    keywords: 'curtains for large windows, curtains for high ceilings, extra long curtains',
    author: 'YN Dream Curtains',
  },
  {
    slug: 'curtains-with-plantation-shutters-adelaide',
    title: 'How to Style Curtains with Plantation Shutters in Adelaide Homes',
    excerpt: 'Master the art of layering curtains and shutters together. The ultimate design combination for Adelaide homes — warmth, light control, and luxury.',
    image: shuttersCurtainsImg,
    category: 'Design',
    date: '2026-06-12',
    readTime: '8 min read',
    keywords: 'curtains with plantation shutters adelaide, curtains and shutters together adelaide, layering curtains and shutters',
    author: 'YN Dream Curtains',
  },
  {
    slug: 'rental-property-curtains-adelaide-guide',
    title: 'Adelaide Rental Property Curtains: Landlord & Tenant Guide 2026',
    excerpt: 'Who pays for curtains in an Adelaide rental? Your rights, obligations, and the best cost-effective solutions for landlords and tenants.',
    image: rentalPropertyImg,
    category: 'Guides',
    date: '2026-06-14',
    readTime: '9 min read',
    keywords: 'curtains for rental property adelaide, rental curtains adelaide, landlord curtains adelaide',
    author: 'YN Dream Curtains',
  },
  {
    slug: 'new-build-curtains-adelaide-guide',
    title: 'New Build Home Curtains Adelaide: Builder\'s Finish vs Custom Guide 2026',
    excerpt: 'Don\'t accept the builder\'s curtain package. Learn why custom curtains are better value and how to time your new home window treatments perfectly.',
    image: newBuildImg,
    category: 'Guides',
    date: '2026-06-16',
    readTime: '8 min read',
    keywords: 'curtains for new homes adelaide, new build curtains adelaide, builder finish curtains adelaide',
    author: 'YN Dream Curtains',
  },
  {
    slug: 'how-long-do-curtains-last-replacement-guide',
    title: 'How Long Do Curtains Last? Adelaide Replacement Guide 2026',
    excerpt: 'Fading, flaking, or just looking tired? Learn when it\'s time to replace your curtains and how Adelaide\'s harsh UV affects fabric lifespan.',
    image: replacementImg,
    category: 'Tips',
    date: '2026-06-18',
    readTime: '7 min read',
    keywords: 'how long do curtains last, when to replace curtains, curtain lifespan adelaide',
    author: 'YN Dream Curtains',
  },
  {
    slug: 'curtains-adelaide-hills-homes-guide',
    title: 'Curtains for Adelaide Hills Homes: Style, Climate & Bushfire Guide 2026',
    excerpt: 'From thermal insulation to bushfire-rated fabrics — the definitive curtain guide for Stirling, Aldgate, Crafers and Hills living.',
    image: hillsImg,
    category: 'Guides',
    date: '2026-06-20',
    readTime: '9 min read',
    keywords: 'curtains adelaide hills, curtains stirling adelaide, bushfire curtains adelaide hills',
    author: 'YN Dream Curtains',
  }
];

export default blogPosts;
